import { Geometry, HorizontalAlign, Rect, Size, VerticalAlign } from ".././MyHelpers";
import { Settings } from "../Settings";
import { MyCanvas } from "./MyCanvas";
import { ISprite } from "./Sprite/ISprite";
 
 export class SlotSymbolSprite
{
	// // idle image, when animation is not running
	// private idleImage: Sprite = null;

	// // original size of image
	// private idleSrcRect: PixelRect = null;
	// private idleIndex: number = 0;

	// // size of image, when drawn on canvas
	// private idleDestRect: PixelRect = null;

	// sprite
	private sprite: ISprite = null;

	// size of animation, when drawn on canvas
	private runningDestRect: Rect = null;


	// is animation playing or is idle?
	private isPlaying: boolean = false;

	constructor(canvasSize: Size, sprite: ISprite, idleSpriteIndex: number)
	{
		// fit and center
		//let canvasRect: PixelRect = new PixelRect(0, 0, canvasSize.Width, canvasSize.Height);

		// // idle
		// this.idleImage = idleImage;
		// this.idleSrcRect = new PixelRect(0, 0, idleImage.config.props.width, idleImage.config.props.width);
		// this.idleIndex = idleSpriteIndex;
		// this.idleDestRect = Geometry.FitRect(this.idleSrcRect, canvasRect, HorizontalAlign.Center, VerticalAlign.Center);

		// running
		this.sprite = sprite;
		// this.runningDestRect = this.idleDestRect;

		// if (!sprite.IsDecoded) 
		// 	ERROR
	}

	// private DrawIdle(canvas: MyCanvas): void
	// {
	// 	let destRect: PixelRect = Geometry.FitRect(this.idleSrcRect, canvas.rect, HorizontalAlign.Center, VerticalAlign.Center);
	// 	canvas.context.drawImage(

	// 		// image to draw
	// 		this.idleImage.shared.decodedFrames[this.idleIndex],

	// 		// source
	// 		this.idleSrcRect.x,
	// 		this.idleSrcRect.y,
	// 		this.idleSrcRect.width,
	// 		this.idleSrcRect.height,

	// 		// destination
	// 		destRect.x,
	// 		destRect.y,
	// 		destRect.width,
	// 		destRect.height,
	// 	);
	// }

	// private DrawPlaying(canvas: MyCanvas): void
	// {
	// 	let currentFrameRect: PixelRect = this.sprite.CurrentFrameRect();
	// 	let destRect: PixelRect = Geometry.FitRect(currentFrameRect, canvas.rect, HorizontalAlign.Center, VerticalAlign.Center);

	// 	canvas.context.drawImage(
			
	// 		// image to draw
	// 		this.sprite.image,

	// 		// source
	// 		currentFrameRect.x,
	// 		currentFrameRect.y,
	// 		currentFrameRect.width,
	// 		currentFrameRect.height,

	// 		// destination
	// 		destRect.x,
	// 		destRect.y,
	// 		destRect.width,
	// 		destRect.height,
	// 	);
	// }

	public Sprite(): ISprite
	{
		return this.sprite;
	} 

	private DrawDecoded(canvas: MyCanvas, drawIdle: boolean)
	{
		// idle frame is first frame (index 0)
		// let currentFrameIndex: number = 0;

		// if (!drawIdle)
		// 	currentFrameIndex = this.sprite.CurrentFrameIndex();

		let currentFrame = this.sprite.CurrentFrame;
		let currentFrameRect: Rect = this.sprite.CurrentFrameRect;
		let currentFrameIndex: number = 0;

		if (drawIdle)
		{
			currentFrame = this.sprite.IdleFrame;
			currentFrameRect = this.sprite.IdleFrameRect;
			currentFrameIndex = this.sprite.IdleFrameIndex;
		}
		else
		{
			currentFrame = this.sprite.CurrentFrame;
			currentFrameRect = this.sprite.CurrentFrameRect;
			currentFrameIndex = this.sprite.CurrentFrameIndex;
		}

		let destRect = Geometry.FitRect(currentFrameRect, canvas.rect, HorizontalAlign.Center, VerticalAlign.Center);

		//canvas.context.save();

		if (currentFrameIndex != 0)
		{
			//canvas.context.filter = "blur(1px)";
		}

		canvas.context.drawImage(
			
			// image to draw
			currentFrame,

			// source
			currentFrameRect.x,
			currentFrameRect.y,
			currentFrameRect.width,
			currentFrameRect.height,

			// destination
			destRect.x,
			destRect.y,
			destRect.width,
			destRect.height,
		);

		

		if (Settings.SpriteFrameDebugging)
		{
			canvas.context.save()
			canvas.context.font = "60px Arial";
			canvas.context.textBaseline = "top";
			canvas.context.fillStyle = "red";
			canvas.context.fillText(currentFrameIndex.toString(), 0, 0);
			canvas.context.restore();
		}

		//canvas.context.restore();
	}

	//
	public Start(): void
	{
		this.isPlaying = true;

		if (this.sprite != null) {
			this.sprite.Restart(true);
		}
	}

	//
	public Stop(): void {
		this.isPlaying = false;

		if (this.sprite != null) {
			this.sprite.Stop();
		}
	}

	public Reset() 
	{
		if (this.sprite != null) {
			this.sprite.Reset();
		}
	}

	//
	Update(): void
	{
		if (this.isPlaying && this.sprite != null)
		{
			// update sprite
			this.sprite.Update(null);
		}
	}

	Draw(canvas: MyCanvas)
	{
		canvas.context.clearRect(0, 0, canvas.size.Width, canvas.size.Height);

		//let idle: boolean = this.isPlaying && this.sprite != null;
		this.DrawDecoded(canvas, !this.isPlaying);

		// // red square around symbol
		// canvas.context.beginPath();
		// canvas.context.lineWidth = 1;
		// canvas.context.strokeStyle = "red";
		// canvas.context.rect(
		// 	this.idleDestRect.x,
		// 	this.idleDestRect.y,
		// 	this.idleDestRect.width,
		// 	this.idleDestRect.height
		// ); 
		// canvas.context.stroke();
	}

	DrawFirts(canvas: MyCanvas){
		canvas.context.clearRect(0,0,canvas.size.Width, canvas.size.Height);
		this.DrawDecoded(canvas, true);
	}


    public IsPlaying(): boolean
    {
        return this.isPlaying;
    }
}
